/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Carousel (carousel)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { CmsAssetSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const CarouselFieldsSchema = z
  .object({
    heading: z.string(),
    items: z.array(
      z
        .object({
          item_id: z.string(),
          image: CmsAssetSchema,
          image_alt: z.string(),
          title: z.string(),
          description: z.string().nullish(),
          cta: RawCmsCtaSchema.nullish(),
        })
        .passthrough(),
    ),
  })
  .passthrough()
